// Personal information

// Skills data for About page
export const skills = [
    { name: "Graphic Design", level: 95 },
    { name: "UI/UX Design", level: 90 },
    { name: "Brand Identity", level: 85 },
    { name: "Motion Graphics", level: 75 },
];

// Company Achievements for About page
export const achievements = [
    {
        title: "120+ Projects Completed",
        category: "Projects",
        year: "2023",
        description: "Successfully delivered over 120 design projects across various industries, maintaining 98% client satisfaction rate."
    },
    {
        title: "85+ Happy Clients",
        category: "Client Success",
        year: "2023",
        description: "Built lasting relationships with clients ranging from startups to established enterprises, with 85% returning for additional projects."
    },
    {
        title: "5+ Years Experience",
        category: "Experience",
        year: "2019-2024",
        description: "Proven track record with years of experience creating compelling visual solutions for brands and businesses."
    }
];

// Contact information
export const contactInfo = {
    email: "arvixcreative@gmail.com",
    phone: "01645076455",
    location: "01No. Goli, Sakib Tower, Keranihat, Satkania, Chattogram, Bangladesh",
    socialMedia: {
        facebook: "https://www.facebook.com/arvix.creative",
        instagram: "https://www.instagram.com/arvix.creative",
        behance: ""
    }
};